export const COLOR_PALETTE = [
  '#E6194B',
  '#3CB44B',
  '#4363D8',
  '#F58231',
  '#911EB4',
  '#46F0F0',
  '#F032E6',
  '#BCF60C',
  '#FABEBE',
  '#008080',
  '#E6BEFF',
  '#9A6324',
  '#AAFFC3',
  '#FFD8B1',
  '#800000',
  '#000075',
  '#808000'
];
